import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../auth-service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  email = '';
  password = '';
  constructor(private authService: AuthService) { }

  ngOnInit() {
  }

  onLogin(loginForm: NgForm) {
    const username = loginForm.value.username;
    const password = loginForm.value.password;
    this.authService.signinUser(username, password);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/login/login.component.ts